import { useState } from 'react'
import SignupForm from 'components/Forms/SignupForm'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { useNavigate } from 'react-router-dom'
import { changeEmail, changeStep, resetFormSteps } from 'store/formStepsSlice'
import { useConfirmSignupMutation, useSignupMutation } from 'services/auth'
import { useNotification } from 'hooks/useNotification'
import SignUpVerificationCodeForm from 'components/Forms/SignUpVerificationCodeForm'

const emailStep = 1
const verificationCodeStep = 2

const Signup = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { sendSuccessNotification } = useNotification()
  const email = useAppSelector((state) => state.formSteps.email)
  const step = useAppSelector((state) => state.formSteps.step)
  const [verificationCode, setVerificationCode] = useState('')
  const [isLimitedTries, setIsLimitedTries] = useState(false)
  const [signup, { isLoading }] = useSignupMutation()
  const [confirmationSignup, { isLoading: isLoadingConfirmation }] =
    useConfirmSignupMutation()

  const handleEmailSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const formData = new FormData(event.currentTarget)
    const name = formData.get('name') as string
    const emailForm = formData.get('email') as string
    const password = formData.get('password') as string

    const response: any = await signup({
      username: emailForm,
      full_name: name,
      password
    })
    if (response?.data) {
      dispatch(changeEmail(emailForm))
      dispatch(changeStep(verificationCodeStep))
    }
  }

  const handleSubmitVerificationCode = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault()

    const response: any = await confirmationSignup({
      username: email,
      confirmation_code: verificationCode
    })

    if (response.data) {
      dispatch(resetFormSteps())
      sendSuccessNotification('Your email has been successfully verified.')
      navigate(`/`)
    }

    const isIncorrectCodeError = response.error && response.error.status === 401
    if (isIncorrectCodeError) {
      resetVerificationInputs()
      return
    }

    const isLimitRetries = response.error && response.error.status === 500
    if (isLimitRetries) {
      setIsLimitedTries(true)
      resetVerificationInputs()
      return
    }

    if (response.error) {
      resetVerificationInputs()
    }
  }

  const handleCodeVerificationBackButton = () => {
    dispatch(changeStep(emailStep))
  }

  const resetVerificationInputs = () => {
    setVerificationCode('')
    const verificationCodeElement = document.querySelector(
      '.ReactInputVerificationCode__item'
    ) as HTMLElement
    verificationCodeElement.focus()
  }

  return (
    <div data-testid="module-signup-affiliate">
      {step === 1 && (
        <SignupForm
          formId="component-forms-phone-signup-affiliate"
          title={`Sign up`}
          buttonText="Get started"
          handleSubmit={handleEmailSubmit}
          isLoading={isLoading}
        />
      )}
      {step === 2 && (
        <SignUpVerificationCodeForm
          formId="component-forms-verificationCode-signup-affiliate"
          title="Check your email"
          buttonText="Verify code"
          handleBackButton={handleCodeVerificationBackButton}
          handleSubmit={handleSubmitVerificationCode}
          verificationCode={verificationCode}
          setVerificationCode={setVerificationCode}
          isLoading={isLoadingConfirmation}
          isLimitedTries={isLimitedTries}
          setIsLimitedTries={setIsLimitedTries}
        />
      )}
    </div>
  )
}

export default Signup
